var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("NOSComponent", {
        ref: "NOS_COMPONENT",
        attrs: { component: this.NOS_INSTANCE.components }
      }),
      _c(
        "div",
        { staticClass: "scroll" },
        [
          _c("contents-header", {
            attrs: {
              "bg-type": true,
              "no-radius": true,
              "title-img2": true,
              title: "MOTP-01-07-05-01",
              description: "MOTP-01-07-05-02"
            },
            scopedSlots: _vm._u([
              {
                key: "img2",
                fn: function() {
                  return [_c("i", { staticClass: "icon icon-token-otp-touch" })]
                },
                proxy: true
              }
            ])
          }),
          _c("article", { staticClass: "contents" }, [
            _c("div", { staticClass: "form" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "item-tit" }, [
                  _vm._v(
                    _vm._s(/*OTP 기기 일련번호*/ _vm.$t("MOTP-01-07-05-03"))
                  )
                ]),
                _c("div", { staticClass: "item-desc" }, [
                  _c("div", { staticClass: "form-text-field otp" }, [
                    _c("div", { staticClass: "input-text-field" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "name",
                          placeholder: "12345667898",
                          readonly: "true"
                        },
                        domProps: { value: _vm.getCheckOtp.in.otpUniqIdnfiNo }
                      })
                    ])
                  ])
                ])
              ]),
              _c("div", { staticClass: "form-text-field" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { for: "name" } },
                  [
                    _vm._v(
                      _vm._s(/*인증코드 (6자리)*/ _vm.$t("MOTP-01-07-05-04"))
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "input-text-field" },
                  [
                    _c("otp-input", {
                      attrs: {
                        NOS_INSTANCE_REFERANCE: _vm.NOS_INSTANCE,
                        isInputHidden: false
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c("div", { staticClass: "btn-area--full fixed" }, [
        _c(
          "button",
          {
            class:
              "btn md " +
              (_vm.getCheckOtp.in.otpUniqIdnfiNo !== "" &&
              _vm.getCheckOtp.in.otp.length === 6
                ? "normal"
                : "disabled"),
            on: { click: _vm.FN001 }
          },
          [_vm._v(_vm._s(/*인증하기*/ _vm.$t("MOTP-01-07-05-05")))]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }